// Module
var code = "<mm-card caption=\"$ctrl.caption\" sub-caption=\"$ctrl.subCaption\" icon=\"$ctrl.icon\" url=\"$ctrl.url\" is-loading=\"$ctrl.isLoading\"> <mm-card-content> <ul class=\"list-unstyled\"> <li ng-repeat=\"site in $ctrl.sites\">{{site.name}}</li> </ul> </mm-card-content> </mm-card> ";
// Exports
var _module_exports = code;;
var path = '/App/Modules/Gui/Components/Widgets/SitesList/SitesListWidget.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;